import { optionsToMap } from '../utils/common';
import { Option } from './option';

/** 状态枚举 */
export enum Status {
  YES = '1',
  NO = '0',
}

/** 状态选项 */
export const statusOptions: Option<Status>[] = [
  { value: Status.YES, label: '是' },
  { value: Status.NO, label: '否' },
];

/** 状态文本 */
export const statusTexts = optionsToMap(statusOptions);

/** 【枚举】预测类型 */
export enum PredictType {
  /** 预测支出 */
  EXPEND = 1,
  /** 预测收入 */
  INCOME = 2,
}

/** 【选项】预测类型 */
export const PredictTypeOptions: Option<PredictType>[] = [
  { value: PredictType.EXPEND, label: '预测支出' },
  { value: PredictType.INCOME, label: '预测收入' },
];

/** 【选项】锁定状态 */
export const LockFlagOptions: Option<number>[] = [
  { value: 1, label: '锁定' },
  { value: 0, label: '解锁' },
];
